import React, { useCallback, useMemo, useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryBase from "../components/EntryBase";
import EntryGrid from "../components/EntryGrid";
import EntryImages from "../components/EntryImages";
import EntryFiles from "../components/EntryFiles";
import EntrySetting from "../components/EntrySetting";
import DataTree from "../components/DataTree";
import DropZone from "../components/DropZone";
import Headline from "../components/Headline";
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import {
    isEmpty, getformid, getcontroller, getsubkey, getWindowDimensions, setglobaldata, FormatDate,
    NumConv, DicVal, getglobaldata, DeepCopy, initializedata, RandomKey, Savestorage, Getstorage,
    GetDesitRound, GetRound, isEnabled, CellType, numformat, removeglovaldata, Round, Floor
} from '../modules/appLibrary';
import { cfFileUpload, cfNewUploadFile, cfMargeUploadFiles } from '../modules/commodule';
import { setimagelist } from '../modules/imagedlgstore';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import EntryLayout from '../components/EntryLayout';
import { changestatus, listtabs, entryformlock, entrytriggercall,readonly,reports } from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup } from '../modules/toolpanelstore';
import { AgGridReact } from "ag-grid-react";
import { themeBalham } from 'ag-grid-community';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));


export const OrderS = props => {

    const panelsdef = [];
    const G_id = { BASE: "0", ROW: "1", IMAGE: "pic",  FILE: "file", TOTAL:"T1" }
    const primarykeys = ["d_order_s_no", "d_order_s_row_no", "d_order_s_allot_no"];

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const entrylock = useSelector(state => state.form.entryformlock);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);
    const themestyle = useSelector(state => state.form.themestyle);
    const AGRef = useRef();
    const fnc = useRef();
    const EntrybodyRef = useRef(null);
    const apiRefrow = useRef({ grid: undefined, column: undefined });
    const apiReftotal = useRef({ grid: undefined, column: undefined });
    const apirow = apiRefrow.current;
    const apitotal = apiReftotal.current;
    const allotgridRef = useRef(null);
    const CalcParam = useRef({taxrate:0.1, amtround:1, taxround:1});
    const locationstate = useRef(null);    //遷移State

    const entrydataRef = useRef(null);    //基本情報データ
    const orderrowsRef = useRef(null);    //発注明細データ
    const ordercolRef = useRef(null);     //発注明細列情報  
    const totalRef = useRef(null);        //発注合計データ
    const totalcolRef = useRef(null);   　//発注合計列情報  
    const imageRef = useRef(null);        //画像
    const fileRef = useRef(null);         //ファイル  

    const shops = useRef([]);           //配分倉庫
    const storeallot = useRef([]);      //配分データ
    const storeorder = useRef([]);      //前回発注データ

    const modifyRef = useRef(false);    //変更フラグ
    const menuinfo = useSelector(state => state.form.menuinfo);
    const formstatus = useSelector(state => state.form.status);
    const formlock = useSelector(state => state.form.entryformlock);
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);     //全カラム情報
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [rowmode, setrowmode] = useState(0);      //0:発注明細 1:倉庫配分
    const [rowData, setRowData] = useState([]);     //倉庫配分データ
    const [columnDefs, setcolumnDefs] = useState([]);
    const [rowDragManaged, setrowDragManaged] = useState(true);
    const [update, setUpdata] = useState(false);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [supallot, setsupallot] = useState(false);
    const [isDragActive, setIsDragActive] = useState(false);
    const search = useLocation().search;

    const dispatch = useDispatch();
    const CELLTYPE = CellType();
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);
    const scrollRef = useRef(null);
    const RowNodeId = data => data.rowid;
    const formid = getformid("OrderS", props.location.search);
    const controller = getcontroller("OrderS", props.location.search);
    const subkey = getsubkey(props.location.search);
    const reportsRef = useRef(null);


    const actionurl = {
        "insert": "orders/Insert",
        "update": "orders/Update",
        "delete": "orders/Delete",
        "saveas": "orders/SaveAs",
        "storageadd": "orders/AddStorage",
        "storagerowdel": "orders/StorageRowdel",
        "upload": "orders/Upload",
    }
    const navmenu = [
        { status: "ENTRY FORM", menuid: "print", icon: "print", label: "発注書発行" },
        { status: "ENTRY FORM", menuid: "sep"},
        { status: "ENTRY FORM", menuid: "recievecreate", icon: "library_add_check", label: "倉庫配分入荷データ一括作成", class: "allot" },
        { status: "ENTRY FORM", menuid: "sep", class: "allot" },
        { status: "ENTRY FORM", menuid: "formupload", icon: "upload_file", label: "関連ファイルUpload", title: "関連ファイルをアップロードします" },
        { status: "ENTRY FORM", menuid: "sep" },
        { status: "ENTRY FORM", menuid: "datatree", icon: "account_tree", label: "Data Tree" },
        { status: "VIEW", menuid: "print", icon: "print", label: "発注書発行" },
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title:"現在のシート内容をExcelに出力します" },
        { status: "VIEW", menuid: "sep" },
        { status: "VIEW", menuid: "upload", icon: "upload_file", label: "関連ファイルUpload", title: "関連ファイルをアップロードします" },
        { status: "VIEW", menuid: "sep" },
        { status: "VIEW", menuid: "listdatatree", icon: "account_tree", label: "Data Tree" },
    ]

    //動作抑止
    const suppressaction = [
        { type: "0", action: "INSERT" },
        { type: "1", action: "INSERT" },
        { type: "2", action: "INSERT" },
        { type: "2", action: "UPDATE" }
    ];

    function rerender() {
        setUpdata(update ? false : true);
    }
    function statusKey(id) {
        return formid + "entry_" + id;
    }
    function onDragEnter(e) {
        if (entrylock) return;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setIsDragActive(true);
        }
    };
    function FileDropClose() {
        setIsDragActive(false);
    }

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        //ListTabを取得
        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    setpanel(data.panels);
                    dispatch(reports(data.reports));
                    dispatch(setentrypanel({
                        layouts: data.layouts, prelayout: data.prelayout,
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        fitColumn: data.fitColumn
                    }));
                    reportsRef.current = data.reports;
                    setcolumninfo(data.colinfo);
                    setcolumns(data.columns);
                    let fields = data.colinfo.filter(e => e.logpid === G_id.BASE);
                    settextfieldsall(fields);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    //列情報初期化
                    ordercolRef.current = null;
                    totalcolRef.current = null;

                    if (data.prelayout) {   //レイアウト復元
                        RestoreLayout(data.panels, fields);
                    }

                    //遷移state取得
                    let state = props.location.state;   //history.push
                    if (isEmpty(state) && !isEmpty(window.history.state)) {
                        if ("status" in window.history.state) {
                            //go back
                            state = window.history.state;
                        }
                    }
                    locationstate.current = state;
                    if (!isEmpty(state)) {
                        if ("code" in state) {
                            clearform();
                            dispatch(changestatus(state.code === "" ? "NEW FORM" : "ENTRY FORM"));
                        }
                    }
                    fnc.current.wait(false);
                }
            });
    }, [search]);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1); //セクションCLOSEボタン
    }, [menuinfo]);


    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    useEffect(() => {
        if (isEmpty(entrydataRef.current)) return;
        if (formstatus === "COPY FORM") {
            entrydataRef.current["d_order_s_no"] = "";
            entrydataRef.current["d_order_s_createac"] = "";
            entrydataRef.current["d_order_s_createdate"] = "";
            entrydataRef.current["d_order_s_updateac"] = "";
            entrydataRef.current["d_order_s_update"] = "";
            //受入ロック解除
            for (let i = 0; i < orderrowsRef.current.length; i++) {
                orderrowsRef.current[i]["lockrow"] = false;
            }
            setrowDragManaged(true);    //行入れ替え可
            setsliplock(false);
            rerender();
        }
    }, [formstatus]);


    //遷移state状態表示
    function callshow() {
        if (locationstate.current.code !== "") {
            Show(undefined, locationstate.current.code)
        } else {
            if (!isEmpty(locationstate.current.acceptno)) {
                clearform();
                if (entrydataRef.current === null) entrydataRef.current = {};
                AcceptAction(locationstate.current.acceptno, locationstate.current.accepttype);
            }
        }
        locationstate.current = null;   //最初の１度のみ
    }

    function setsliplock(value) {
        dispatch(entryformlock(value));
    }

    function onFirstDataRendered(param, id) {
        if (id === G_id.ROW) {
            apiRefrow.current.grid = param.api;
            apiRefrow.current.column = param.columnApi;
        }
        if (id === G_id.TOTAL) {
            apiReftotal.current.grid = param.api;
            apiReftotal.current.column = param.columnApi;
            if (isEmpty(locationstate.current)) {
            //    RowDataChanged();
            } else {
                //遷移表示
                callshow();
            }
        }
    }

    function MenuQueryAction(action, param) {
        if (action === 'delete' && formstatus === "UPDATE") {
            if (param.tabvalue !== '0') {
                fnc.current.warnmsg("このシートのデータは削除できません");
                return false;
            }
        }
        return true;
    }
    function MenuAction(action, finallycallback, param) {
        LayoutSaveStorage();   //現在レイアウト保持
        if (action === 'save') Save(finallycallback);
        if (action === 'delete') Delete(finallycallback);
        if (action === "clear") {
            clearform(true);
        }
        if (action === 'linkfield') {
            switch (finallycallback.table) {
                case "d_order_s":
                    let type = "100";
                    let col = textfields.find(e => e.columnid === finallycallback.field);
                    if (col !== undefined) {
                        type = col.type;
                        let key = finallycallback.field + "_" + type;
                        document.getElementById(key).focus();
                        document.getElementById(key).select();
                    }
                    Jump(G_id.BASE, type);
                    break;
                case "d_order_s_row":
                    Jump(G_id.ROW);
                    AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, apirow.grid);
                    break;
                default:
                    break;
            }
        }
        if (reportsRef.current.some(e => e.id === action)) {   //帳票
            let code = [];
            if (formstatus === "ENTRY FORM") {
                code = [edittingcode];
            } else {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (primarykeys[i] in param[0]) {
                        for (let j = 0; j < param.length; j++) {
                            code.push(param[j][primarykeys[i]]);
                        }
                        break;
                    }
                }
            }
            if (code.length === 0) return;
            fnc.current.postaxios('common/Printout', { controller: controller, id: action, keys: code },
                {
                    onSuccess: function (data) {
                        let params = {
                            "excelfile": data.returnData["filename"],
                            "dnfile": data.returnData["dnfile"]
                        }
                        fnc.current.filedownload("excel/ExcelDownload", params);
                        fnc.current.wait(false);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
            return;
        }
        if (action === 'datatree') {
            DataTreeOpen(edittingcode);
        }
        if (action === 'listdatatree') {
            for (let i = 0; i < primarykeys.length; i++) {
                if (primarykeys[i] in param[0]) {
                    setedittingcode(param[0][primarykeys[i]]);
                    DataTreeOpen(param[0][primarykeys[i]]);
                    return;
                }
            }
        }
        function DataTreeOpen(code) {
            fnc.current.postaxios('orders/GetDataTree', { "code": code },
                {
                    onSuccess: function (data) {
                        fnc.current.wait(false);
                        fnc.current.datatreeopen(data.list);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
        }
        if (action === 'recievecreate') {
            if (modifyRef.current) {    //redux modifyを使うとrenderが発生するため
                let msg = "データが変更されています。変更前データで作成を行いますがよろしいですか？";
                fnc.current.confmsg(msg, () => recievecreate());
            } else {
                recievecreate();
            }
        }
        //倉庫配分入荷データ作成
        function recievecreate() {
            fnc.current.postaxios('orders/RecieveCreateCheck', { "code": edittingcode },
                {
                    onSuccess: function (data) {
                        fnc.current.wait(false);
                        fnc.current.confmsg(data.request, () => Apply());
                    },
                    errmsg: "処理に失敗しました"
                }
            )
            function Apply() {
                fnc.current.postaxios('orders/RecieveCreate', { "code": edittingcode },
                    {
                        onSuccess: function (data) {
                            fnc.current.success();
                            fnc.current.wait(false);
                        },
                        errmsg: "処理に失敗しました"
                    }
                )
            }
        }
    }
    function Show(data,pushcode) {
        let code = "";
        if (data === undefined) {
            if (!isEmpty(pushcode)) {   //history.push
                code = pushcode;
                setedittingcode(code);
            } else {
                code = edittingcode;    //再表示
            }
        } else {
            setglobaldata("entryrowdata", data);
            if (data !== null) {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (data[primarykeys[i]]) {
                        code = data[primarykeys[i]]; break;
                    }
                }
            }
            setedittingcode(code);
        }
        if (isEmpty(columninfo)) return false;    //読み込み前
        clearform(code==="");
        //データ読み込み
        LoadData(code);
        return true;
    }
    function LoadData(code) {
        if (code === "") return;
        fnc.current.postaxios('orders/GetData', { "code": code, "colinfo": columninfo, "controller": controller },
            {
                onSuccess: function (data) {
                    try {
                        if (code !== "") {
                            //ViewからのMyField値を引継ぎ
                            let row = getglobaldata("entryrowdata");
                            if (!isEmpty(row)) {
                                if ("d_order_s_memo" in row) data.data.d_order_s_memo = row.d_order_s_memo;
                                if ("d_order_s_sticky" in row) data.data.d_order_s_sticky = row.d_order_s_sticky;
                                if ("d_order_s_mytags" in row) data.data.d_order_s_mytags = row.d_order_s_mytags;
                            }
                            fnc.current.margeMaster(data.master);
                            entrydataRef.current = data.data;
                            orderrowsRef.current = data.row;
                            storeorder.current = DeepCopy(orderrowsRef.current); //発注データ保存
                            shops.current = data.shops;
                            setstoreallot(data.allotdata);
                            imageRef.current = data.images;
                            fileRef.current = data.files;
                            dispatch(setimagelist(data.images));
                            var totalfields = ["d_order_s_qty", "d_order_s_amount", "d_order_s_tax", "d_order_s_taxinamt", "d_order_s_taxkind",
                                "d_order_s_rate", "d_order_s_currencyamt"];     //必須
                            var totalcols = columninfo.filter(e => e.logpid === "T1");
                            for (let i = 0; i < totalcols.length; i++) {
                                if (totalfields.indexOf(totalcols[i].columnid) === -1)
                                    totalfields.push(totalcols[i].columnid);
                            }
                            var total = { rowid: "TOTAL", grip: "計" };
                            for (let i = 0; i < totalfields.length; i++) {
                                total[totalfields[i]] = data.data[totalfields[i]];
                            }
                            totalRef.current = [total];
                            let tax = (NumConv(data.data["d_order_s_taxrate"]) / 100).toString();
                            CalcParam.current = {
                                taxrate: tax, amtround: data.data["m_splr_roundamt"], taxround: data.data["m_splr_roundtax"],
                                taxdate: FormatDate(data.data["d_order_s_date"]), splrcode: data.data["d_order_s_splr"]
                            };
                            taxApply(tax, data.taxs, true);

                            //受入済の場合行入れ替え不可
                            let lock = data.row.some(e => e.lockrow);
                            setrowDragManaged(!lock);
                            setsliplock(data.data["d_order_s_lock"] !== "0");   //伝票ロックか
                            if (formlock) entrydataRef.current["d_order_s_lock"] = "1";
                            rerender();
                        }
                        fnc.current.wait(false);
                    } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                    }
                },
                onError: function (data) {
                    fnc.current.wait(false);
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                    dispatch(changestatus("VIEW"));
                }
            }
        )
    }
    function setstoreallot(allotdata) {
        var newdata = [];
        let rows = orderrowsRef.current;
        if (rows.length === 0 || shops.current.length === 0) {
            storeallot.current = [];
            return;
        }
        for (let r = 0; r < rows.length; r++) {
            let allot = [];
            for (let i = 0; i < shops.current.length; i++) {
                let row = { code: shops.current[i].code, name: shops.current[i].name, rowid: rows[r].rowid }
                var info = allotdata.find(e => e.rowid === rows[r].rowid && e.code === shops.current[i].code);
                if (!isEmpty(info)) {
                    row["rollqty"] = info.rollqty;
                    row["qty"] = info.qty;
                    row["stock"] = info.stock;
                    row["arrival"] = info.arrival;
                }
                allot.push(row);
            }
            let data = DeepCopy(rows[r]);
            data["callRecords"] = allot;
            newdata.push(data);
        };
        storeallot.current = newdata;
    }

    //リストValueChange
    function ListCellChange(params, columninfo) {
        //簡易計算処理
        var data = null;
        if (params.colDef.field === "d_order_s_row_qty") {
            if (columninfo.some(e => e.columnid === "d_order_s_row_amount") && columninfo.some(e => e.columnid === "d_order_s_row_price")) {
                let value = NumConv(params.newValue) * NumConv(DicVal(params.data, "d_order_s_row_price", 0));
                value = GetRound(value, 1);   //四捨五入暫定
                data = { d_order_s_row_amount: value };
                if (columninfo.some(e => e.columnid === "d_order_s_row_currencyamt") && columninfo.some(e => e.columnid === "d_order_s_row_currency")) {
                    let value = NumConv(params.newValue) * NumConv(DicVal(params.data, "d_order_s_row_currency", 0));
                    let col = columninfo.find(e => e.columnid === "d_order_s_row_currencyamt");
                    if (!isEmpty(col)) {
                        value = GetDesitRound(value, 1, col.decimalplace);   //四捨五入暫定
                    }
                    data["d_order_s_row_currencyamt"] = value;
                }
            }
        }
        if (params.colDef.field === "d_order_s_row_price") {
            if (columninfo.some(e => e.columnid === "d_order_s_row_amount") && columninfo.some(e => e.columnid === "d_order_s_row_qty")){
                let value = NumConv(params.newValue) * NumConv(DicVal(params.data, "d_order_s_row_qty", 0));
                value = GetRound(value, 1);   //四捨五入暫定
                data = { d_order_s_row_amount: value };
            }
        }
        if (params.colDef.field === "d_order_s_row_currency") {
            if (columninfo.some(e => e.columnid === "d_order_s_row_currencyamt") && columninfo.some(e => e.columnid === "d_order_s_row_qty")) {
                let value = NumConv(params.newValue) * NumConv(DicVal(params.data, "d_order_s_row_qty", 0));
                let col = columninfo.find(e => e.columnid === "d_order_s_row_currencyamt");
                if (!isEmpty(col)) {
                    value = GetDesitRound(value, 1, col.decimalplace);   //四捨五入暫定
                }
                data = { d_order_s_row_currencyamt: value };
            }
        }
        return data;
    }

    //リスト編集セル制御
    function ListlockCell(params, edit, status, tabvalue) {
        if (!edit) return edit;
        if (status === "INSERT") {
            if (params.colDef.field === "d_order_s_mytags" ||
                params.colDef.field === "d_order_s_sharetags" ||
                params.colDef.field === "d_order_s_sticky" ||
                params.colDef.field === "d_order_s_memo") {
                return false;
            }
        }
        if (status === "UPDATE") {
            if (DicVal(params.data, "d_order_s_lock", "") === "1") return false;    //伝票ロック
            if (tabvalue === "2") {
                if (params.colDef.colinfo.table !== "d_order_s_allot") return false;
            }
            if (params.colDef.field === "d_order_s_row_code" ||
                params.colDef.field === "d_order_s_row_colno" ||
                params.colDef.field === "d_order_s_row_colnm" ||
                params.colDef.field === "d_order_s_row_size" ||
                params.colDef.field === "d_order_s_row_sizenm") {
                return false;   //編集不可　判定困難なため暫定
            }
        }
        return edit;
    }
    //明細カラム定義
    function ColdefSpecial(column) {
        if (formstatus !== "ENTRY FORM") return;
        //受入されている場合編集不可
        if (column.field === "d_order_s_row_code" ||
            column.field === "d_order_s_row_colno" ||
            column.field === "d_order_s_row_colnm" ||
            column.field === "d_order_s_row_size" ||
            column.field === "d_order_s_row_sizenm" ) {
            column.editable = function (params) {
                if (params.context.entrylock) return false;
                else
                    return !isEnabled(params.node.data["lockrow"]);
            }
            column.cellStyle = function (params) {
                if (!params.context.entrylock && isEnabled(params.node.data["lockrow"])) {
                    return { backgroundColor: '#eee' };
                } else {
                    return null;
                }
            }
        }
    }

    function rowmodeChange() {
        if (rowmode === 0) {    //発注明細→倉庫配分
            storeRowData();
            setrowmode(1);
            createAllotdata(false);
        } else {                //倉庫配分→発注明細
            storeallot.current = AGRef.current.GetDatasource(allotgridRef.current.api); //配分データ保存
            setrowmode(0);
            removeglovaldata("OrderSCopyRate", false);    //コピーされた配分比率クリア
        }
    }

    function addcalcorder() {
        storeRowData();
        fnc.current.searchlistopen({
            label: "材料計算発注リスト",
            multiple: true,
            rowmode: true,
            data: { dataid: 'd_calc_order:smatl', initial: true },
            rowid: null,
            currowid: null,
            doApply: Apply,
        });
        function Apply(e, mode) {
            fnc.current.searchlistclose();
            //重複除去
            var codes = [];
            for (let i = 0; i < e.items.length; i++) {
                let data = e.items[i].data;
                let result = orderrowsRef.current.find(e => DicVal(e, "d_order_s_row_calcno") === data["d_calc_order_no"]);
                if (isEmpty(result)) {
                    codes.push({ code: data["d_calc_order_no"] });
                }
            }
            if (codes.length === 0) return;
            fnc.current.postaxios('orders/GetCalclist', { "shops": codes, "colinfo": columninfo },
                {
                    onSuccess: function (data) {
                        //末尾の無効行を削除
                        orderrowsRef.current = AGRef.current.TrimEndRow(orderrowsRef.current, columninfo, ordercolRef.current);
                        for (let i = 0; i < data.row.length; i++) {
                            data.row[i]["d_order_s_row_index"] = 0;
                            data.row[i]["rowid"] = RandomKey();
                            orderrowsRef.current.push(data.row[i]);
                        }
                        orderrowsRef.current.push({ "rowid": RandomKey() });
                        RowDataChanged();
                        rerender();
                        fnc.current.wait(false);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
        }
    }

    function addshop() {
        storeallot.current = AGRef.current.GetDatasource(allotgridRef.current.api); //配分データ保存
        fnc.current.searchlistopen({
            label: "倉庫（配分先）",
            multiple: true,
            rowmode: true,
            data: { dataid: 'm_whse', datatype: CELLTYPE.MASTERCODE, initial: true },
            rowid: null,
            currowid: null,
            doApply: Apply,
        });
        function Apply(e, mode) {
            fnc.current.searchlistclose();
            for (let i = 0; i < e.items.length; i++) {
                let data = e.items[i].data;
                let result = shops.current.find(e => e.code === data.code);
                if (isEmpty(result)) {
                    shops.current.push({ code: data.code, name: data.m_whse_name });
                }
            }
            let result = shops.current.sort(function (a, b) {
                return (a.code < b.code) ? -1 : 1;
            });
            shops.current = result;
            createAllotdata(true);
        }
    }

    const formatNumber = (params) => {
        let colinfo = params.colDef.colinfo;
        if (isEmpty(colinfo)) return params.value;
        if (colinfo.datatype === CELLTYPE.NUM) {
            var number = Number(params.value);
            return numformat(number, colinfo);
        }
        return params.value;
    };
    function createAllotdata(shopchange) {
        let g_column = DeepCopy(ordercolRef.current);
        var colDef = g_column.filter(e => e.field !== 'grip');
        let column = { field: 'total', colId:'total', headerName: "配分計", width: 80 };
        AGRef.current.SetColDefTypeInfo(CELLTYPE.NUM, column);
        colDef.push(column);
        column = {
            field: 'rest', colId: 'rest', headerName: "配分残", width: 80,
            cellStyle: function (params) {
                if (Number(params.value) < 0) {
                    return { backgroundColor: 'pink' };
                }else if (Number(params.value) > 0) {
                    return { backgroundColor: 'honeydew' };
                } else {
                    return { backgroundColor: 'inherit' };
                }
            }
        };
        AGRef.current.SetColDefTypeInfo(CELLTYPE.NUM, column);
        colDef.push(column);
        colDef = colDef.map(obj => {
            obj.editable = false;
            obj.resizable = true;
            obj.filterType = "multi";
            obj.menuTabs = ['filterMenuTab'];
            obj.valueFormatter = formatNumber;
            obj.sortable = false;
            if (obj.colId !== "d_order_s_row_qty" && obj.colId !== "total" && obj.colId !== "rest") {
                obj.cellRenderer = "agGroupCellRenderer";
            } else {
                obj.pinned = 'right';
            }
            return obj
        });
        setcolumnDefs(colDef);

        var newdata = [];
        let rows = orderrowsRef.current;
        if (rows.length === 0 || shops.current.length === 0) {
            setRowData(newdata);
            return;
        }
        if (JSON.stringify(rows) === JSON.stringify(storeorder.current) && !shopchange) {
            //変更なしの場合前回データセット
            setRowData(storeallot.current); 
            return;
        }
        storeorder.current = DeepCopy(rows); //発注データ保存
        fnc.current.postaxios('orders/GetAllotinfo', { "shops": shops.current, "rowdata": rows },
            {
                onSuccess: function (data) {
                    for (let r = 0; r < rows.length; r++) {
                        if (isEmpty(rows[r].d_order_s_row_code) && isEmpty(rows[r].d_order_s_row_colno) && isEmpty(rows[r].d_order_s_row_size)) continue;
                        let allot = [];
                        for (let i = 0; i < shops.current.length; i++) {
                            let row = { code: shops.current[i].code, name: shops.current[i].name, rowid:rows[r].rowid }
                            var rowdata = storeallot.current.find(e => e.rowid === rows[r].rowid);
                            if (!isEmpty(rowdata)) {
                                let rec = rowdata.callRecords.find(e => e.code === shops.current[i].code);
                                if (!isEmpty(rec)) {
                                    row["rollqty"] = rec.rollqty;
                                    row["qty"] = rec.qty;
                                }
                            }
                            var info = data.allotdata.find(e => e.rowid === rows[r].rowid && e.code === shops.current[i].code)
                            if (!isEmpty(info)) {
                                row["stock"] = info.stock;
                                row["arrival"] = info.arrival;
                            }
                            //定義セット
                            row["rollqtyinfo"] = columninfo.find(e => e.columnid === "d_order_s_row_rollqty");
                            row["qtyinfo"] = columninfo.find(e => e.columnid === "d_order_s_row_qty");
                            allot.push(row);
                        }
                        let row = DeepCopy(rows[r]);
                        row["callRecords"] = allot;
                        newdata.push(row);
                    };
                    setRowData(newdata);
                    fnc.current.wait(false);
                },
                errmsg: "処理に失敗しました"
            }
        )
    }

    //配分計、配分残を算出セット
    function setTotalAllotQty(node, qty) {
        if (isEmpty(AGRef.current)) return;
        let src = AGRef.current.GetDatasource(allotgridRef.current.api);
        let data = src.find(e => e.rowid === node.rowid);
        if (isEmpty(data)) return;
        let rows = data.callRecords;
        let total = 0;
        for (let i = 0; i < rows.length; i++) {
            if (node.code === rows[i].code) {
                total += qty;
            } else {
                if (!isNaN(rows[i].qty)) {
                    total += Number(rows[i].qty);
                }
            }
        }
        let rowNode = allotgridRef.current.api.getRowNode(node.rowid);
        if (!isEmpty(rowNode)) {
            rowNode.setDataValue("rest", data['d_order_s_row_qty'] - total);
            rowNode.setDataValue("total", total);
        }
    }
    function qtyParser(params) {
        let colinfo = params.column.colId === "rollqty" ? params.data["rollqtyinfo"] : params.data["qtyinfo"];
        if (colinfo === null) return params.newValue;
        if (!isFinite(params.newValue))
            return '';

        let num = Floor(Number(params.newValue), colinfo.decimalplace);
        return num;
    }
    const qtyFormatter = (params) => {
        var number = 0;
        if (!isNaN(params.value)) {
            number = Number(params.value);
        }
        setTotalAllotQty(params.data, number);
        return currencyFormatter(params);
    };
    const currencyFormatter = (params) => {
        if (isNaN(params.value)) return '';
        let colinfo = params.column.colId === "rollqty" ? params.data["rollqtyinfo"] : params.data["qtyinfo"];
        if (colinfo === null) return params.value;
        return numformat(params.value, colinfo);
    };

    const detailCellRendererParams = (params) => {
        //反数列表示/非表示
        var hide = false
        if (!isEmpty(columninfo)) {
            hide = !columninfo.some(e => e.columnid === "d_order_s_row_rollqty");   //反数定義なしの場合非表示
            if (!hide) {
                var coldefs = params.api.getColumnState();
                if (!coldefs.some(e => e.colId === "d_order_s_row_rollqty" && !e.hide)) hide = true;   //反数非表示
            }
        }
        return {
            detailGridOptions: {
                columnDefs: [
                    { headerName: "コード", field: 'code' },
                    { headerName: "配分先", field: 'name' },
                    {
                        headerName: "配分反数", field: 'rollqty', editable: true, cellClass: "ag-right-aligned-cell", filter: "agNumberColumnFilter", width: 100,
                        valueParser: qtyParser,
                        valueFormatter: currencyFormatter,
                        hide: hide
                    },
                   {
                        headerName: "配分数", field: 'qty', editable: true, cellClass: "ag-right-aligned-cell", filter: "agNumberColumnFilter", width: 100,
                        valueParser: qtyParser,
                        valueFormatter: qtyFormatter
                    },
                    { headerName: "在庫数", field: 'stock', cellClass: "ag-right-aligned-cell", filter: "agNumberColumnFilter", width: 100, valueFormatter: currencyFormatter },
                    { headerName: "累計入荷数", field: 'arrival', cellClass: "ag-right-aligned-cell", filter: "agNumberColumnFilter", width: 100, valueFormatter: currencyFormatter },
                ],
                defaultColDef: {
                    sortable: true,
                    filter: true,
                    resizable: true
                },
                columnMenu: "legacy",
                rowSelection: 'multiple',
                enableRangeSelection: true,
                suppressMultiRangeSelection: true,
                getContextMenuItems: getContextMenuItems,
                enableFillHandle: true,
                fillHandleDirection: 'y'
            },
            getDetailRowData: (params) => {
                params.successCallback(params.data.callRecords);
            },
        };
    }

 
    function getContextMenuItems(params) {
        var lock = entrydataRef.current["d_order_s_lock"] ==="1";
        var result = [];
        if (!lock) {
            result = [{
                name: '配分先削除',
                action: function () {
                    const selectedRows = params.api.getSelectedRows();
                    if (!selectedRows || selectedRows.length === 0) {
                        fnc.current.warnmsg("行を選択してください");
                        return;
                    }
                    if (orderrowsRef.current.some(e => e.lockrow)) {
                        //削除可能かチェック
                        fnc.current.postaxios("orders/ExistShopAllot",
                            {
                                code: entrydataRef.current["d_order_s_no"],
                                rowdata: selectedRows
                            },
                            {
                                onSuccess: function (data) {
                                    if (data.request === "OK") {
                                        let msg = "すべての発注明細から選択された配分先を削除します。よろしいですか？";
                                        fnc.current.confmsg(msg, () => deleteshop(selectedRows));
                                    }
                                    else {
                                        if (selectedRows.length === 1) fnc.current.warnmsg("受入済の配分先の為削除できません");
                                        else fnc.current.warnmsg("受入済の配分先が含まれています");
                                    }
                                    fnc.current.wait(false);
                                },
                                errmsg: "処理に失敗しました"
                            }
                        )
                        return;
                    }
                    let msg = "すべての発注明細から選択された配分先を削除します。よろしいですか？";
                    fnc.current.confmsg(msg, () => deleteshop(selectedRows));
                },
            },
                'separator'
            ];
        }
        var result2 = [{
            name: '選択配分先タグ登録',
            tooltip: '表示中の配分先にタグを追加します',
            action: function () {
                if (shops.current === null) {
                    fnc.current.warnmsg("配分先が存在しません");
                    return;
                }
                if (shops.current.length === 0) {
                    fnc.current.warnmsg("配分先が存在しません");
                    return;
                }
                fnc.current.formdialogopen({ title: "配分先TAG登録", inputname: "TAG", placeholder: "TAG名を入力します", onApply: (param) => addTagshop(param) });
            },
        }];
        return lock?result2:[...result, ...result2];
    };
    function addTagshop(value) {
        fnc.current.postaxios("common/AddTagShop",
            {
                code: value,
                rowdata: shops.current
            },
            {
                onSuccess: function (data) {
                    fnc.current.wait(false);
                    fnc.current.success();
                    fnc.current.formdialogclose();
                },
                errmsg: "処理に失敗しました"
            }
        )
    }
    function deleteshop(rows) {
        storeallot.current = AGRef.current.GetDatasource(allotgridRef.current.api); //配分データ保存
        for (let i = 0; i < rows.length; i++) {
            let code = rows[i].code;
            shops.current = shops.current.filter(e => e.code !== code);
            for (let r = 0; r < storeallot.current.length; r++) {
                let row = storeallot.current[r];
                let rec = row.callRecords.filter(e => e.code !== code);
                row.callRecords = rec;
            }
        }
        setRowData(storeallot.current);
    }

    function onAllotFirstDataRendered(params){
        setTimeout(function () {
            params.api.forEachNode(function (node) {
                node.setExpanded(true);
            });
        }, 0);
    };

    function allotcheck(rows) {
        let rest = false;
        for (let i = 0; i < storeallot.current.length; i++) {
            let row = rows.find(e => e.rowid === storeallot.current[i].rowid);
            if (isEmpty(row)) continue;
            let t = 0;
            for (let j = 0; j < storeallot.current[i].callRecords.length; j++) {
                let allot = storeallot.current[i].callRecords[j];
                t += NumConv(allot.qty);
            }
            //発注数＜配分数
            if (t > NumConv(row["d_order_s_row_qty"])) return false;
            //発注数＞配分数
            if (t < NumConv(row["d_order_s_row_qty"])) rest = true;
        }
        return rest?9:true;
    }
    function Save(finallycallback) {
        if (rowmode === 0) {
            storeRowData();
            //無効行を除く
            let row = orderrowsRef.current;
            storeallot.current = storeallot.current.filter(e => row.find(r => r.rowid, e.rowid) !== null);
        }
        else storeallot.current = AGRef.current.GetDatasource(allotgridRef.current.api);

        let allot = [];
        for (let i = 0; i < storeallot.current.length; i++) {
            allot = [...allot, ...storeallot.current[i].callRecords];
        }
        let row = orderrowsRef.current;
        if (!AGRef.current.ExistValidRow(orderrowsRef.current, columninfo, ordercolRef.current)) {
            fnc.current.warnmsg("有効な発注明細が存在しません");
            return;
        }
        var newfiles = (formstatus === "ENTRY FORM" ? [] : cfNewUploadFile(imageRef, fileRef)); //v1.4
        if (newfiles.length > 10) {
            fnc.current.warnmsg("新規登録できるアップロードファイル数は10までです。");
            return;
        }
        if (supallot) {
            Apply();
        } else {
            if (allot.length === 0) {
                let msg = "倉庫配分が入力されていません。登録してよろしいですか？";
                fnc.current.confmsg(msg, () => Apply());
            } else {
                switch (allotcheck(row)) {
                    case false:
                        fnc.current.warnmsg("配分数が発注数を超えている明細が存在します");
                        return;
                    case true:
                        Apply();
                        break;
                    default:
                        let msg = "配分残が存在します。登録してよろしいですか？";
                        fnc.current.confmsg(msg, () => Apply());
                        break;
                }
            }
        }
        function Apply() {
            if (isEmpty(entrydataRef.current)) entrydataRef.current = {};
            if (!isEmpty(totalRef.current)) {
                for (let key in totalRef.current[0]) {
                    if (key === "rowid") continue;
                    entrydataRef.current[key] = totalRef.current[0][key]
                }
            }
            const paramdata = {
                "controller": formid,
                "data": entrydataRef.current,
                "row": row,
                "shops": shops.current,
                "allot": allot,
                "images": imageRef.current,
                "files": fileRef.current,
                "colinfo": columninfo,
                "code": edittingcode
            }
            fnc.current.postaxios(formstatus === "ENTRY FORM" ? "orders/UpdateEntry" : "orders/InsertEntry", paramdata,
                {
                    onSuccess: function (data) {
                        if (data.warning.length === 0) {
                            fnc.current.modify(false);
                            let code = data.request;
                            if (formstatus !== "ENTRY FORM") {
                                entrydataRef.current["d_order_s_no"] = data.request;
                                setedittingcode(data.request);
                                dispatch(changestatus("ENTRY FORM"));
                            }
                            if (newfiles.length !== 0) {        //v1.4
                                //新規ファイルアップロード
                                cfFileUpload("orders", code, newfiles, fnc, () => LoadData(code));
                            } else {
                                fnc.current.success();
                                if (formstatus === "ENTRY FORM") {
                                    data.data['rowid'] = Getrowid();    //更新行キー
                                    finallycallback(data.data);
                                }
                                LoadData(code);     //再表示
                            }
                        }
                        else {
                            setrowmode(0);
                            let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                            fnc.current.showwarndescription(msg, data.warning);
                        }
                        fnc.current.wait(false);
                    },
                    errmsg: "登録に失敗しました"
                }
            )
        }
    }

   function Delete(finallycallback) {
       const param = {
           rowdata: [{ "rowid": edittingcode }],
           controller: controller
       }
        fnc.current.postaxios("orders/Delete", param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.success();
                        finallycallback(edittingcode, primarykeys);
                    }
                    else {
                        fnc.current.warnmsg(["このデータは削除できません", data.warning[0].message]);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "削除に失敗しました"
            }
        )
    }
    function Getrowid() {
        let data = getglobaldata("entryrowdata");
        if (isEmpty(data)) return "";
        return data.rowid;
    }

    //受入処理
    function AcceptAction(value, type) {
        fnc.current.postaxios('orders/GetAccept', { "code": value, "type": type, "colinfo": columninfo },
            {
                onSuccess: function (data) {
                    clearform();
                    fnc.current.margeMaster(data.master);
                    entrydataRef.current = data.data;
                    orderrowsRef.current = data.rowdata;
                    storeorder.current = DeepCopy(orderrowsRef.current); //発注データ保存
                    var totalfields = ["d_order_s_qty", "d_order_s_amount", "d_order_s_tax", "d_order_s_taxinamt", "d_order_s_taxkind",
                        "d_order_s_rate", "d_order_s_currencyamt"];     //必須
                    var totalcols = columninfo.filter(e => e.logpid === "T1");
                    for (let i = 0; i < totalcols.length; i++) {
                        if (totalfields.indexOf(totalcols[i].columnid) === -1)
                            totalfields.push(totalcols[i].columnid);
                    }
                    var total = { rowid: "TOTAL", grip: "計" };
                    for (let i = 0; i < totalfields.length; i++) {
                        total[totalfields[i]] = data.data[totalfields[i]];
                    }
                    totalRef.current = [total];
                    CalcParam.current = {
                        taxrate: data.data["taxrate"], amtround: data.data["m_splr_roundamt"], taxround: data.data["m_splr_roundtax"],
                        taxdate: FormatDate(data.data["d_order_s_date"]), splrcode: data.data["d_order_s_splr"]
                    };
                    setrowDragManaged(false);
                    setsliplock(false);

                    RowDataChanged();
                    fnc.current.wait(false);
                },
                onError: function (data) {
                    fnc.current.warnmsg("受入データが存在しません");
                    fnc.current.wait(false);
                },
                errmsg: "処理に失敗しました"
            }
        )
    }

    //行挿入前イベント
    function QueryInsertRow(row) {
        if (formstatus === "ENTRY FORM") {
            //指定行が受け入れ済の場合エラー
            if (isEnabled(row.data.lockrow)) {
                fnc.current.warnmsg("この明細は受入済の為行挿入できません");
                return false;
            }
            //指定行以降に受け入れ済が存在する場合エラー
            for (let i = row.rowIndex + 1; i < orderrowsRef.current.length; i++) {
                if (isEnabled(orderrowsRef.current[i]["lockrow"])) {
                    fnc.current.warnmsg("受入済明細が存在する為行挿入できません");
                    return false;
                }
            }
        }
        return true;
    }
    //行削除前イベント
    function QueryRemoveRow(rows) {
        if (formstatus === "ENTRY FORM") {
            for (let i = 0; i < rows.length; i++) {
                if (isEnabled(rows[i].lockrow)) {
                    if (rows.length === 1) fnc.current.warnmsg("この明細は受入済の為行削除できません");
                    else fnc.current.warnmsg("受入済の明細が含まれている為行削除できません");
                    return false;
                }
            }
        }
        return true;
    }

    //Basic Data Change
    function ValueChanged(id, value) {
       if (id === "d_order_s_splr") {  //仕入先
           if (value === CalcParam.current.splrcode) return;
           CalcParam.current.splrcode = value;
            if (isEmpty(value)) {
                CalcParam.current.amtround = 1;
                CalcParam.current.taxround = 1;
                totalRef.current[0]["d_order_s_taxkind"] = "0";
                settaxkind();
                RowDataChanged();   //再計算
                return;
            }
            let data = fnc.current.getMaster("m_splr", value);
            if (!isEmpty(data)) {
                if ("m_splr_roundamt" in data && "m_splr_roundtax" in data && "m_splr_taxkind" in data) {
                    CalcParam.current.amtround = data["m_splr_roundamt"];
                    CalcParam.current.taxround = data["m_splr_roundtax"];
                    totalRef.current[0]["d_order_s_taxkind"] = data["m_splr_taxkind"];
                    settaxkind();
                    RowDataChanged();   //再計算
                    return;
                }
            }
            //仕入先データ取得
            fnc.current.getMasterdata("m_splr", value, "",
                [
                    { columnid: "amtround", dbcolumn: "m_splr_roundamt" },
                    { columnid: "taxround", dbcolumn: "m_splr_roundtax" },
                    { columnid: "taxkind", dbcolumn: "m_splr_taxkind" },
                ], null, (data) => splrApply(data))
        }
        if (id === "d_order_s_date") {  //発注日
            if (value === CalcParam.current.taxdate) return;
            entrydataRef.current[id] = value;
            CalcParam.current.taxdate = value;
            fnc.current.getTaxrate(value, (tax, taxs) => taxApply(tax, taxs));
        }
        //外部からの参照がある項目
        let col = columninfo.find(e => e.columnid === id);
        if (!isEmpty(col)) {
            if (col.extriggerref) {
                dispatch(entrytriggercall(id));
            }
        }
        function splrApply(data) {
            if (isEmpty(data)) {
                CalcParam.current.amtround = 1;
                CalcParam.current.taxround = 1;
                totalRef.current[0]["d_order_s_taxkind"] = "0";
                settaxkind();
            } else {
                fnc.current.setMaster(data);
                CalcParam.current.amtround = data["m_splr_roundamt"];
                CalcParam.current.taxround = data["m_splr_roundtax"];
                totalRef.current[0]["d_order_s_taxkind"] = data["m_splr_taxkind"];
                settaxkind();
            }
            RowDataChanged();   //再計算
        }
        function settaxkind() {
            if (EmptyPanel(G_id.TOTAL)) return;
            if (isEmpty(apitotal.grid)) return;
            let rowNode = apitotal.grid.getRowNode("TOTAL");
            if (!isEmpty(rowNode)) {
                rowNode.setDataValue("d_order_s_taxkind", totalRef.current[0]["d_order_s_taxkind"]);
            }
        }
    }
    function taxApply(tax, taxs, formatonly, force) {
        if (isEnabled(force)) CalcParam.current.taxrate = tax;
        if (CalcParam.current.taxrate !== tax) {
            let rate = NumConv(CalcParam.current.taxrate) * 100;
            let exist = false;
            for (let key in taxs) {
                if (taxs[key] === rate.toString()) {
                    exist = true; break;
                }
            }
            if (!exist) CalcParam.current.taxrate = tax;
            else tax = CalcParam.current.taxrate;
        }
        var taxid = columninfo.find(e => e.columnid === "d_order_s_taxrate");
        if (!isEmpty(taxid)) {
            var newtax = "";
            var newoptions = [];
            for (let key in taxs) {
                newoptions.push({ code: taxs[key], name: "" });
                newtax += taxs[key] + ",";
            }
            var oldtax = "";
            for (let i = 0; i < taxid.options.length; i++) {
                oldtax += taxid.options[i].code + ",";
            }
            if (oldtax !== newtax && !isEmpty(totalcolRef.current)) {
                taxid.options = newoptions;
                var target = totalcolRef.current.find(e => e.field === "d_order_s_taxrate");
                if (!isEmpty(target)) {
                    target.colinfo = taxid;
                }
            }
        }
        if (isEnabled(formatonly)) return;
        totalRef.current[0]["d_order_s_taxrate"] = (tax * 100).toString();
        RowDataChanged();   //再計算
    }
     //Total Data Change
   function TotalValueChange(params) {
       if (params.column.colId === "d_order_s_taxrate") {
           if (NumConv(params.value) === 0) {  //選択肢以外の値が指定された場合
               let rowNode = apitotal.grid.getRowNode("TOTAL");
               totalRef.current[0]["d_order_s_taxrate"] = (CalcParam.current.taxrate * 100).toString();
               if (!isEmpty(rowNode)) rowNode.setDataValue("d_order_s_taxrate", CalcParam.current.taxrate * 100);
               return;
           }
           CalcParam.current.taxrate = NumConv(params.value) / 100;
           RowDataChanged();
       }
        if (params.column.colId === "d_order_s_taxkind") {
            RowDataChanged();
        }
        if (params.column.colId === "d_order_s_rate") { //レート
            RowDataChanged(true);
        }
    }
    //Grid Data Change
    function ChangeRowValue(params) {
        storeRowData(G_id.Row);
        let rowidx = params.node.rowIndex;
        if (params.column.colId === "d_order_s_row_code") {
            //C/#、サイズクリア
            orderrowsRef.current[rowidx]["d_order_s_row_colno"] = "";
            orderrowsRef.current[rowidx]["d_order_s_row_colnm"] = "";
            orderrowsRef.current[rowidx]["d_order_s_row_size"] = "";
            orderrowsRef.current[rowidx]["d_order_s_row_sizenm"] = "";
            var node = apiRefrow.current.grid.getDisplayedRowAtIndex(rowidx);
            if (!isEmpty(node)) {
                node.setData(orderrowsRef.current[rowidx]);
            }
        }
        if (params.column.colId === "d_order_s_row_qty" || params.column.colId === "d_order_s_row_price") {
            RowDataChanged();
        }
        if (params.column.colId === "d_order_s_row_currency") { //外貨単価
            RowDataChanged(true);
        }
    }
    function RowValueChanged(colid, targets) {
        if (colid === "d_order_s_row_code") {
            for (let i = 0; i < targets.length; i++) {
                //C/#、サイズクリア
                targets[i]["d_order_s_row_colno"] = "";
                targets[i]["d_order_s_row_colnm"] = "";
                targets[i]["d_order_s_row_size"] = "";
                targets[i]["d_order_s_row_sizenm"] = "";
                var node = apiRefrow.current.grid.getRowNode(targets[i].rowid);
                if (!isEmpty(node)) {
                    node.setData(targets[i]);
                }
            }
        }
        RowDataChanged();
    }

    //Grid Row Data Change
    function RowDataChanged(priceconv) {
        if (isEmpty(orderrowsRef.current)) orderrowsRef.current = [];
        //金額セット
        for (let i = 0; i < orderrowsRef.current.length; i++) {
            if (isEnabled(priceconv)) {
                if (("d_order_s_row_currency" in orderrowsRef.current[i]) && ("d_order_s_rate" in totalRef.current[0])) {
                    //単価＝レート×外貨単価　※レート、外貨単価が０の場合変更なし
                    if (NumConv(orderrowsRef.current[i]["d_order_s_row_currency"] > 0 && NumConv(totalRef.current[0]["d_order_s_rate"]) > 0)) {
                        let price = NumConv(totalRef.current[0]["d_order_s_rate"]) * NumConv(orderrowsRef.current[i]["d_order_s_row_currency"]);
                        price = GetRound(price, CalcParam.current.amtround);
                        orderrowsRef.current[i]["d_order_s_row_price"] = price;
                    }
                }
            }
            let amount = NumConv(orderrowsRef.current[i]["d_order_s_row_qty"]) * NumConv(orderrowsRef.current[i]["d_order_s_row_price"]);
            amount = GetRound(amount, CalcParam.current.amtround);
            let taxfree = 0;
            if ("d_order_s_row_taxfree" in orderrowsRef.current[i])
                taxfree = NumConv(orderrowsRef.current[i]["d_order_s_row_taxfree"]);
            if (totalRef.current[0]["d_order_s_taxkind"] === "1") {    //内税
                let intax = 0;
                if (taxfree === 0) {    //課税
                    //内税額＝税率 /（1 + 税率）* (d_order_s_row_qty * d_order_s_row_price)
                    intax = CalcParam.current.taxrate / (1 + CalcParam.current.taxrate) * amount;
                    intax = GetRound(intax, CalcParam.current.taxround);
                }
                orderrowsRef.current[i]["d_order_s_row_intax"] = intax;
                orderrowsRef.current[i]["d_order_s_row_amount"] = amount - intax;
            } else {                                                    //外税
                //金額＝数量×単価
                orderrowsRef.current[i]["d_order_s_row_intax"] = 0;
                orderrowsRef.current[i]["d_order_s_row_amount"] = amount;
            }
            //外貨金額＝数量×外貨単価
            let curamt = 0;
            if ("d_order_s_row_currency" in orderrowsRef.current[i]) {
                curamt = NumConv(orderrowsRef.current[i]["d_order_s_row_qty"]) * NumConv(orderrowsRef.current[i]["d_order_s_row_currency"]);
                let col = columninfo.find(e => e.columnid === "d_order_s_row_currency");
                if (!isEmpty(col)) {
                    curamt = GetDesitRound(curamt, CalcParam.current.amtround, col.decimalplace);
                }
            }
            orderrowsRef.current[i]["d_order_s_row_currencyamt"] = curamt;

            if (!isEmpty(apiRefrow.current.grid)) {
                var node = apiRefrow.current.grid.getDisplayedRowAtIndex(i);
                if (!isEmpty(node)) node.setDataValue("d_order_s_row_amount", orderrowsRef.current[i]["d_order_s_row_amount"]);
            }
        }
        if (EmptyPanel(G_id.TOTAL)) return;
        let total = { qty: 0, amt: 0, taxamt: 0, tax: 0, curamt: 0 };
        for (let i = 0; i < orderrowsRef.current.length; i++) {
            let taxfree = 0;
            if ("d_order_s_row_taxfree" in orderrowsRef.current[i] )
                taxfree = NumConv(orderrowsRef.current[i]["d_order_s_row_taxfree"]);
            total.qty += NumConv(orderrowsRef.current[i]["d_order_s_row_qty"]);
            total.amt += NumConv(orderrowsRef.current[i]["d_order_s_row_amount"]);
            if (taxfree === 0) {    //課税対象分
                total.taxamt += NumConv(orderrowsRef.current[i]["d_order_s_row_amount"]);
            }
            total.tax += NumConv(orderrowsRef.current[i]["d_order_s_row_intax"]);
            total.curamt += NumConv(orderrowsRef.current[i]["d_order_s_row_currencyamt"]);
        }
        totalRef.current[0]["d_order_s_qty"] = total.qty;
        totalRef.current[0]["d_order_s_amount"] = total.amt;
        if (totalRef.current[0]["d_order_s_taxkind"] === "0") {    //外税
            totalRef.current[0]["d_order_s_tax"] = GetRound(CalcParam.current.taxrate * total.taxamt, CalcParam.current.taxround);
        }
        if (totalRef.current[0]["d_order_s_taxkind"] === "1") {    //内税
            totalRef.current[0]["d_order_s_tax"] = total.tax;
        }
        if (totalRef.current[0]["d_order_s_taxkind"] === "2") {    //非課税
            totalRef.current[0]["d_order_s_tax"] = 0;
        }
        totalRef.current[0]["d_order_s_taxinamt"] = total.amt + totalRef.current[0]["d_order_s_tax"];
        totalRef.current[0]["d_order_s_currencyamt"] = total.curamt;
        if (!isEmpty(apitotal.grid)) {
            let rowNode = apitotal.grid.getRowNode("TOTAL");
            if (!isEmpty(rowNode)) rowNode.setData(totalRef.current[0]);
        }
    }
    //行データ保持
    function storeRowData(panel) {
        if (panel === undefined || panel === G_id.ROW) {
            orderrowsRef.current = AGRef.current.GetDatasource(apirow.grid);
        }
    }

    function Jump(id, type) {
        let offset = 0;
        var panelid = "basepanel" + type;
        if (id === G_id.ROW) panelid = rowmode === 0 ? 'rowGrid' :'allotGrid';
        if (id === G_id.FILE) panelid = 'fileGrid';
        if (id === G_id.IMAGE) panelid = 'imagepanel';
        let elem = document.getElementById(panelid);
        if (isEmpty(elem)) return;
        offset = elem.offsetTop - 50;
        EntrybodyRef.current.scrollTop = offset;
    }

    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        setpanel(newpanel);
    }
    // スクロール位置を保存する
    function saveScrollPos() {
        scrollRef.current = EntrybodyRef.current.scrollTop;
    }
    // スクロール位置を復元する
    function restoreScrollPos() {
        try {
            if (scrollRef.current) EntrybodyRef.current.scrollTop = scrollRef.current;
        } catch { }
    }
    //入力フィールドクリア
    function clearform(newform) {
        setsliplock(false);
        setrowmode(0);
        entrydataRef.current = initializedata(textfieldsall, staff);
        orderrowsRef.current = [{ rowid: RandomKey() }];
        CalcParam.current = { taxrate: 0.1, amtround: 1, taxround: 1 };
        totalRef.current = [{ rowid: "TOTAL", grip: "計", d_order_s_taxkind:"0" }];
        shops.current = [];
        storeallot.current = [];
        dispatch(setimagelist([]));
        imageRef.current = null;
        fileRef.current = null;
        fnc.current.modify(false);
        modifyRef.current = false;
        //列情報初期化
        ordercolRef.current = null;
        totalcolRef.current = null;

        if (isEnabled(newform)) {
            fnc.current.getTaxrate("", (tax, taxs) => taxApply(tax, taxs, false, true));
            //SQL初期値セット
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: textfieldsall },
                {
                    onSuccess: function (data) {
                        for (let key in data.returnData) {
                            var col = textfieldsall.find(e => e.columnid === key);
                            if (!isEmpty(col)) col.initvalue = data.returnData[key];
                        }
                        entrydataRef.current = initializedata(textfieldsall, staff);
                        rerender();
                    },
                }, true
            )
        }

    }
    //レイアウト保持
    function LayoutSaveStorage() {
        //列情報保存
        AGRef.current.SaveColState(statusKey(G_id.ROW), EmptyPanel(G_id.ROW) ? null : apirow.column);
        AGRef.current.SaveColState(statusKey(G_id.TOTAL), EmptyPanel(G_id.TOTAL) ? null : apitotal.column);
        //基本情報保存
        Savestorage(corpkey, account, statusKey(G_id.BASE), textfields);
        //パネルの表示/非表示および並び
        Savestorage(corpkey, account, formid + "panel", panel);
    }
    function EmptyPanel(id, type) {
        try {
            let tbltype = tabletype(id);
            return isEmpty(columns.find(e => e.type === tbltype));
        } catch { return false; }
    }
    //パネル別列情報取得
    function tabletype(id) {
        if (id.substr(0, 1) === "T") {  //Total
            if (isEmpty(columninfo)) return "";
            let col = columninfo.find(e => e.logpid === id);
            if (isEmpty(col)) return '';
            return col.type;
        } else {
            let pnl = panel.find(e => e.id === id);
            if (isEmpty(pnl)) return '';
            return pnl.type;
        }
    }

    //基本項目設定
    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }
    //レイアウト復元
    function RestoreLayout(panels, fields) {
        //パネルの並び
        RestorePanel(panels);
        //基本情報
        RestoreBase(fields)
    }
    function RestorePanel(panel) {
        let paneldata = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(paneldata)) return;
        if (panel.length !== paneldata.length) return;
        for (let i = 0; i < paneldata.length; i++) {
            let item = panel.find(e => e.id === paneldata[i].id && e.type === paneldata[i].type);
            if (isEmpty(item)) return;
            paneldata[i].name = item.name;
            paneldata[i].name2 = item.name2;
            paneldata[i].abbr = item.abbr;
        }
        setpanel(paneldata);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, statusKey(G_id.BASE));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }

    //レイアウト登録
    function SaveLayout(layoutid) {
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            switch (panel[p].id) {
                case G_id.BASE:
                    if (setbase) break;
                    let fds = textfields.filter(x => !x.hide);
                    for (let f = 0; f < fds.length; f++) {
                        coldef.push({
                            headerName: fds[f].columnnm, table: fds[f].table, field: fds[f].columnid, width: fds[f].width,
                            type: fds[f].type
                        });
                    }
                    setbase = true;
                    break;
                case G_id.ROW:
                    cols = AGRef.current.GetshownColDef(apirow.column);
                    break;
                default:
                    continue;
            }
            for (let i = 0; i < cols.length; i++) {
                let col = DeepCopy(cols[i]);
                col.type = tabletype(panel[p].id);
                coldef.push(col);
            }
        }
        //Total Grid
        cols = AGRef.current.GetshownColDef(apitotal.column);
        for (let i = 0; i < cols.length; i++) {
            let col = DeepCopy(cols[i]);
            col.type = tabletype(G_id.TOTAL);
            coldef.push(col);
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト削除
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout)
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト呼び出し
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    //列情報初期化
                    var type = tabletype(G_id.ROW);
                    var coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                    ordercolRef.current = coldef;
                    type = tabletype(G_id.TOTAL);
                    coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                    totalcolRef.current = coldef;
                    setpanel(data.panels);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    setcolumns(data.columns);
                    fnc.current.wait(false);
                },
            }
        )
    }

    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (p.id === G_id.IMAGE) {
            if (isEmpty(imageRef.current)) return true;
            if (imageRef.current.length === 0) return true;
            return p.hide;
        }
        if (p.id === G_id.FILE) {
            if (isEmpty(fileRef.current)) return true;
            if (fileRef.current.length === 0) return true;
            return p.hide;
        }
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }
    //パネルセレクタ
    function panelnavwidth() {
        return windowDimensions.width - 280;
    }

    function getOrderContextMenuItems(params) {
        var result = [
            {
                name: 'Expand(全開)',
                action: function () {
                    setTimeout(function () {
                        params.api.forEachNode(function (node) {
                            node.setExpanded(true);
                        });
                    }, 0);
                },
            },
            {
                name: 'collapse(全閉)',
                action: function () {
                    setTimeout(function () {
                        params.api.forEachNode(function (node) {
                            node.setExpanded(false);
                        });
                    }, 0);
                },
            }
        ];
        var add=['separator',
            {
                name: '発注数を配分計に変更（全行）',
                action: function () {
                    setTimeout(function () {
                        params.api.forEachNode(function (node) {
                            node.setDataValue('d_order_s_row_qty', node.data['total'])
                            let data = orderrowsRef.current.find(e => e.rowid === node.data['rowid']);
                            if (!isEmpty(data)) {
                                data['d_order_s_row_qty'] = node.data['total'];
                            }
                        });
                    }, 0);
                    RowDataChanged();
                    fnc.current.success();
                },
            },
            {
                name: '発注数を配分計に変更（指定行のみ）',
                action: function () {
                    if (isEmpty(params.node)) {
                        fnc.current.warnmsg("指定行のセルで実行してください");
                        return;
                    }
                    let node = params.node;
                    node.setDataValue('d_order_s_row_qty', node.data['total'])
                    let data = orderrowsRef.current.find(e => e.rowid === node.data['rowid']);
                    if (!isEmpty(data)) {
                        data['d_order_s_row_qty'] = node.data['total'];
                    }
                    RowDataChanged();
                    fnc.current.success();
                },
            },
            'separator',
            {
                name: '配分比率をコピー',
                action: function () {
                    if (isEmpty(params.node)) {
                        fnc.current.warnmsg("指定行のセルで実行してください");
                        return;
                    }
                    setglobaldata("OrderSCopyRate", params.node.data);
                    setglobaldata("OrderSCopyRateIndex", params.node.childIndex);
                    fnc.current.success();
                },
            },
            {
                name: '配分比率を適用',
                action: function () {
                    let data = getglobaldata("OrderSCopyRate");
                    if (isEmpty(data)) {
                        fnc.current.warnmsg("配分比率がコピーされていません");
                        return;
                    }
                    let index = getglobaldata("OrderSCopyRateIndex");
                    if (isEmpty(params.node)) {
                        fnc.current.warnmsg("指定行のセルで実行してください");
                        return;
                    }
                    let msg = "コピーされた" + (index + 1) + "行目の比率で発注数を配分セットします。よろしいですか？";
                    fnc.current.confmsg(msg, () => Apply(params, data));

                    function Apply(params, data) {
                        let qty = NumConv(params.node.data["d_order_s_row_qty"]);  //適用行発注数
                        let total = NumConv(data["d_order_s_row_qty"]);            //コピー元配分計
                        let rows = data["callRecords"];
                        let newrows = params.node.data["callRecords"];  //適用データ
                        let t = 0;
                        let max = { index: 0, value: 0 };
                        for (let i = 0; i < newrows.length; i++) {
                            let setrow = newrows[i];
                            let row = rows.find(e => e.code === setrow["code"]);
                            if (isEmpty(row)) {
                                setrow["qty"] = 0; continue;
                            }
                            if (total === 0 || NumConv(row["qty"]) === 0) {  //配分比率＝０
                                setrow["qty"] = 0;
                            } else {
                                let value = Round(qty * (NumConv(row["qty"]) / total), 0);
                                setrow["qty"] = value;
                                t += value;
                                if (max.value < value) {
                                    max.value = value; max.index = i;
                                }
                            }
                        }
                        if (total !== NumConv(data["total"])) { //配分残あり
                            let rest = total - NumConv(data["total"]);
                            let value = Round(qty * (rest / total), 0);
                            t += value;
                            if (max.value < value) {
                                max.value = value; max.index = -1;
                            }
                        }
                        if (t !== qty && max.index !== -1) {
                            newrows[max.index]["qty"] += (qty - t);
                        }
                        var rowdata = DeepCopy(params.node.data);
                        rowdata["callRecords"] = newrows;
                        rowdata["total"] = t;
                        rowdata["rest"] = qty - t;
                        const tran = {
                            update: [rowdata],
                        };
                        params.api.applyTransaction(tran);
                    }
                },
            },
        ];
        return formlock?result:[...result, ...add];
    };
    //リストレイアウト適用
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e => e.type !== type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
    }

    //File Upload 再表示
    function fileuploaded(data) {
        let duplicate = false;
        if (formstatus === 'NEW FORM' || formstatus === 'COPY FORM') {  //v1.4
            if (cfMargeUploadFiles(imageRef, data.images)) duplicate = true;
            if (cfMargeUploadFiles(fileRef, data.files)) duplicate = true;
        } else {
            imageRef.current = data.images;
            fileRef.current = data.files;
        }
        dispatch(setimagelist(imageRef.current));
        rerender();
        //v1.4
        if (duplicate) fnc.current.warnmsg("同名のファイルが存在しました。差し替える場合は元のファイルを削除してからアップロードしてください");
    }
    //panel入れ替え
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };

    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.abbr}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type)}
            />
        </ListItem>
    ));
    const SortablePanelSelector = SortableContainer(({ items }) => {
        var newitem = [];
        for (let i = 0; i < items.length; i++) {
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul style={{ display: 'flex' }}  >
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} disabled={layoutlock}/>
                ))}
            </ul>
        );
    });
    function Contents(props) {
        if (props.panel.id === "0") {
            const baseid = "basepanel" + props.panel.type;
            return (
                <div id={baseid} >
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={props.panel}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                    />
                </div>
            );
        }
        if (props.panel.id === G_id.ROW && props.rowmode===0) {
            return (
                <React.Fragment>
                    <EntryGrid
                        id={props.panel.id}
                        elemid="rowGrid"
                        entrydataRef={entrydataRef}
                        dataRef={orderrowsRef}
                        columnRef={ordercolRef}
                        columninfo={columninfo}
                        columns={columns}
                        modifyRef={modifyRef}
                        type={tabletype(G_id.ROW)}
                        fnc={fnc}
                        onFirstDataRendered={onFirstDataRendered}
                        statusKey={formid + "entry_" + G_id.ROW}
                        ValueChanged={ChangeRowValue}
                        RowValueChanged={RowValueChanged}
                        RemoveRow={RowDataChanged}
                        ColdefSpecial={ColdefSpecial}
                        rowDragManaged={rowDragManaged}
                        QueryRemoveRow={QueryRemoveRow}
                        QueryInsertRow={QueryInsertRow}
                    />
                    {EmptyPanel(G_id.TOTAL) ? null :
                        <EntryGrid
                            id={"T" + props.panel.id}
                            elemid="totalGrid"
                            dataRef={totalRef}
                            columnRef={totalcolRef}
                            columninfo={columninfo}
                            columns={columns}
                            type={tabletype(G_id.TOTAL)}
                            fnc={fnc}
                            onFirstDataRendered={onFirstDataRendered}
                            statusKey={formid + "entry_" + G_id.TOTAL}
                            ValueChanged={TotalValueChange}
                            total={true}
                        />
                    }
                </React.Fragment>
            );
        }
        if (props.panel.id === G_id.ROW && props.rowmode === 1) {
            return (
            <div id="allotGrid" className="ag-theme-balham" style={{ width: '100%' }}>
                    <AgGridReact
                        theme={themeBalham}
                        columnMenu="legacy"
                        ref={allotgridRef}
                        columnDefs={columnDefs}
                        popupParent={document.querySelector('body')}
                        masterDetail={true}
                        detailCellRendererParams={detailCellRendererParams}
                        rowData={rowData}
                        getRowNodeId={RowNodeId}
                        headerHeight={30}
                        domLayout={'autoHeight'}
                        onFirstDataRendered={onAllotFirstDataRendered}
                        getContextMenuItems={getOrderContextMenuItems}
                   />
                </div>
            );
        }
        if (props.panel.id === G_id.IMAGE) {
            return (
                <EntryImages
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={imageRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.id === G_id.FILE) {
            return (
                <EntryFiles
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={fileRef}
                    rerender={rerender}
                />
            )
        }
        return null;

    }
    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={EntrybodyRef} onDragEnter={onDragEnter}>
                {panel.map((p, i) => {
                    return (
                        <Box
                            display={panelhidden(p) ? "none" : "flex"}
                            justifyContent="space-around"
                            alignItems="center"
                            padding="5px"
                        >
                            <Paper
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    padding: 10
                                }}
                            >
                                <div style={{ position: 'relative', marginBottom: 5 }}>
                                    {p.name === '' ? <div style={{ display: 'inline-block', height: 10 }}></div> : p.name}
                                    {p.name2 !== '' ? '-': ''}
                                    <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                                    {p.id !== '0' || layoutlock ? null :
                                        <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                            <IconButton size="small" onClick={() => SetBaseField(p.type)}  >
                                                <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                    {p.id !== '1' ? null :
                                        <React.Fragment>
                                        {rowmode === 0 || formlock ? null :
                                                <div style={{ position: 'absolute', left: 120, top: -7 }}>
                                                    <Button size="small" onClick={addshop}
                                                        style={{
                                                            width: 100, backgroundColor: themestyle.body.back === '#F8F8F8' ? themestyle.maincolor : "#F2F0ED",
                                                            color: themestyle.body.back === '#F8F8F8' ? '#FFF' : '#333', fontWeight: 700
                                                        }}
                                                    >
                                                        配分先追加
                                                    </Button>
                                                </div>
                                        }
                                            {rowmode === 1 || formlock ? null :
                                                <div style={{ position: 'absolute', left: 120, top: -7 }}>
                                                    <Button size="small" onClick={addcalcorder}
                                                        style={{
                                                            width: 130, backgroundColor: themestyle.body.back === '#F8F8F8' ? themestyle.maincolor : "#F2F0ED",
                                                            color: themestyle.body.back === '#F8F8F8' ? '#FFF' : '#333', fontWeight: 700
                                                        }}
                                                    >
                                                        材料計算発注リスト
                                                    </Button>
                                                </div>
                                            }
                                            {supallot ? null :
                                                <div style={{ position: 'absolute', right: 100, top: -3 }}>
                                                    <Button size="small" endIcon={<Icon style={{ fontSize: 16 }}>arrow_forward</Icon>} onClick={rowmodeChange}>
                                                        {rowmode === 0 ? "倉庫配分" : "発注明細"}
                                                    </Button>
                                                </div>
                                            }
                                        </React.Fragment>
                                    }
                                    {layoutlock || sectionclose ? null :
                                        <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                            <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}  >
                                                <Icon style={{ fontSize: 16 }}>close</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                </div>
                                <Contents panel={p} rowmode={ rowmode} />
                            </Paper >
                        </Box>
                    );
                })}
            </div>
        );
    }

    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                uploaded={fileuploaded}
                entrycallback={MenuAction}
                queryaction={MenuQueryAction}
                condition={true}
                entryform={true}
                tabs={true}
                show={Show}
                primaryid={'d_order_s'}
                primarykey={primarykeys}
                parentedit={true}
                navmenu={formlock || supallot ? navmenu.filter(e => (formlock && e.menuid !== 'formupload') || (supallot && e.class !== 'allot')) : navmenu}
                suppressaction={suppressaction}
                lockcell={ListlockCell}
                listcellchange={ListCellChange}
                slipsave={true}
            >
                <EntryForm />
            </MasterBase>
            <EntryLayout
                columninfo={textfieldsall}
                textfields={textfields}
                onAppry={SetLayout}
            />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={() => fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <Headline columninfo={columninfo} entrydata={entrydataRef.current} ></Headline>
                    <div style={{ position: 'absolute', top: 60, left: 210 }}>
                        <Paper
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                flexWrap: 'wrap',
                                listStyle: 'none',
                                p: 0.2,
                                m: 0,
                            }}
                            component="ul"
                            elevation={0}
                            style={{ backgroundColor: "transparent", width: panelnavwidth() }}
                        >
                            {/*Panel Selector*/}
                            <SortablePanelSelector
                                axis={"x"}
                                items={panel}
                                onSortEnd={onPanelSortEnd}
                                distance={2}
                            />
                        </Paper>
                    </div>
                </div>
                : null}
            <AGFunc ref={AGRef} />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
            <DataTree code={edittingcode} />
            <DropZone
                code={edittingcode}
                open={isDragActive}
                onclose={FileDropClose}
                actionurl={actionurl}
                uploaded={fileuploaded}
            />
        </div>
    );
};
